import {
    FETCH_TOP_COACHES_BY_HOURS_REQUEST,
    FETCH_TOP_COACHES_BY_HOURS_SUCCESS,
    FETCH_TOP_COACHES_BY_HOURS_FAILURE,
    FETCH_COACHES_BY_UNIQUE_STUDENTS_REQUEST,
    FETCH_COACHES_BY_UNIQUE_STUDENTS_SUCCESS,
    FETCH_COACHES_BY_UNIQUE_STUDENTS_FAILURE,
    FETCH_COACHES_TOTAL_RECORDS_REQUEST,
    FETCH_COACHES_TOTAL_RECORDS_SUCCESS,
    FETCH_COACHES_TOTAL_RECORDS_FAILURE,
    FETCH_RECORDS_BY_TYPE_OF_HOURS_REQUEST,
    FETCH_RECORDS_BY_TYPE_OF_HOURS_SUCCESS,
    FETCH_RECORDS_BY_TYPE_OF_HOURS_FAILURE,
    FETCH_RECORDS_BY_TYPE_OF_STUDENTS_REQUEST,
    FETCH_RECORDS_BY_TYPE_OF_STUDENTS_SUCCESS,
    FETCH_RECORDS_BY_TYPE_OF_STUDENTS_FAILURE,
    FETCH_RECORDS_GROUP_BY_COACHES_REQUEST,
    FETCH_RECORDS_GROUP_BY_COACHES_SUCCESS,
    FETCH_RECORDS_GROUP_BY_COACHES_FAILURE,
    FETCH_TOP_PERFORMING_COACHES_REQUEST,
    FETCH_TOP_PERFORMING_COACHES_SUCCESS,
    FETCH_TOP_PERFORMING_COACHES_FAILURE,
    FETCH_COACH_DETAILS_REQUEST,
    FETCH_COACH_DETAILS_SUCCESS,
    FETCH_COACH_DETAILS_FAILURE,
    FETCH_STUDENTS_DETAILS_REQUEST,
    FETCH_STUDENTS_DETAILS_SUCCESS,
    FETCH_STUDENTS_DETAILS_FAILURE

} from './CoachAppHoursAnalyticsTypes';

const initialCoachAppHoursAnalyticsState = {
    // Total coaches records
    totalCoachesRecords: {
        data: [],
        loading: false,
        error: null
    },
    // Records by type of students
    recordsByTypeOfStudents:{
        data: [],
        loading: false,
        error: null
    },

    recordsByTypeOfHours: {
        data: [],
        loading: false,
        error: null
    },

    // Top coaches by total hours
    topCoachesByHours: {
        data: [],
        loading: false,
        error: null
    },
    
    // Coaches by unique students
    coachesByUniqueStudents: {
        data: [],
        loading: false,
        error: null
    },
    
    // Records grouped by coaches
    recordsGroupByCoaches: {
        data: [],
        loading: false,
        error: null
    },
    
    // Top performing coaches analytics
    topPerformingCoaches: {
        data: null,
        loading: false,
        error: null
    },
    
    // Coach details
    coachDetails: {
        data: null,
        loading: false,
        error: null
    },
    
    // Students details
    studentsDetails: {
        data: null,
        loading: false,
        error: null
    }
    
};

export const coachAppHoursAnalyticsReducer = (state = initialCoachAppHoursAnalyticsState, action) => {
    switch (action.type) {
        // Total coaches records
        case FETCH_COACHES_TOTAL_RECORDS_REQUEST:
            return {
                ...state,
                totalCoachesRecords: {
                    ...state.totalCoachesRecords,
                    loading: true,
                    error: null
                }
            };
        case FETCH_COACHES_TOTAL_RECORDS_SUCCESS:
            return {
                ...state,
                totalCoachesRecords: {
                    ...state.totalCoachesRecords,
                    loading: false,
                    data: action.payload || [],
                    error: null
                }
            };
        case FETCH_COACHES_TOTAL_RECORDS_FAILURE:
            return {
                ...state,
                totalCoachesRecords: {
                    ...state.totalCoachesRecords,
                    loading: false,
                    data: [],
                    error: action.payload
                }
            };
        // Records by type of hours
        case FETCH_RECORDS_BY_TYPE_OF_HOURS_REQUEST:
            return {
                ...state,
                recordsByTypeOfHours: {
                    ...state.recordsByTypeOfHours,
                    loading: true,
                    error: null
                }
            };
        case FETCH_RECORDS_BY_TYPE_OF_HOURS_SUCCESS:
            return {
                ...state,
                recordsByTypeOfHours: {
                    ...state.recordsByTypeOfHours,
                    loading: false,
                    data: action.payload || [],
                    error: null
                }
            };
        case FETCH_RECORDS_BY_TYPE_OF_HOURS_FAILURE:
            return {
                ...state,
                recordsByTypeOfHours: {
                    ...state.recordsByTypeOfHours,
                    loading: false,
                    data: [],
                    error: action.payload
                }
            };
        // Records by type of students
        case FETCH_RECORDS_BY_TYPE_OF_STUDENTS_REQUEST:
            return {
                ...state,
                recordsByTypeOfStudents: {
                    ...state.recordsByTypeOfStudents,
                    loading: true,
                    error: null
                }
            };
        case FETCH_RECORDS_BY_TYPE_OF_STUDENTS_SUCCESS:
            return {
                ...state,
                recordsByTypeOfStudents: {
                    ...state.recordsByTypeOfStudents,
                    loading: false,
                    data: action.payload || [],
                    error: null
                }
            };
        case FETCH_RECORDS_BY_TYPE_OF_STUDENTS_FAILURE:
            return {
                ...state,
                recordsByTypeOfStudents: {
                    ...state.recordsByTypeOfStudents,
                    loading: false,
                    data: [],
                    error: action.payload
                }
            };
        // Top coaches by hours
        case FETCH_TOP_COACHES_BY_HOURS_REQUEST:
            return {
                ...state,
                topCoachesByHours: {
                    ...state.topCoachesByHours,
                    loading: true,
                    error: null
                }
            };
        case FETCH_TOP_COACHES_BY_HOURS_SUCCESS:
            return {
                ...state,
                topCoachesByHours: {
                    ...state.topCoachesByHours,
                    loading: false,
                    data: action.payload.data || [],
                    error: null
                }
            };
        case FETCH_TOP_COACHES_BY_HOURS_FAILURE:
            return {
                ...state,
                topCoachesByHours: {
                    ...state.topCoachesByHours,
                    loading: false,
                    data: [],
                    error: action.payload
                }
            };
            
        // Coaches by unique students
        case FETCH_COACHES_BY_UNIQUE_STUDENTS_REQUEST:
            return {
                ...state,
                coachesByUniqueStudents: {
                    ...state.coachesByUniqueStudents,
                    loading: true,
                    error: null
                }
            };
        case FETCH_COACHES_BY_UNIQUE_STUDENTS_SUCCESS:
            return {
                ...state,
                coachesByUniqueStudents: {
                    ...state.coachesByUniqueStudents,
                    loading: false,
                    data: action.payload || [],
                    error: null
                }
            };
        case FETCH_COACHES_BY_UNIQUE_STUDENTS_FAILURE:
            return {
                ...state,
                coachesByUniqueStudents: {
                    ...state.coachesByUniqueStudents,
                    loading: false,
                    data: [],
                    error: action.payload
                }
            };
        
        // Records grouped by coaches
        case FETCH_RECORDS_GROUP_BY_COACHES_REQUEST:
            return {
                ...state,
                recordsGroupByCoaches: {
                    ...state.recordsGroupByCoaches,
                    loading: true,
                    error: null
                }
            };
        case FETCH_RECORDS_GROUP_BY_COACHES_SUCCESS:
            return {
                ...state,
                recordsGroupByCoaches: {
                    ...state.recordsGroupByCoaches,
                    loading: false,
                    data: action.payload || [],
                    error: null
                }
            };
        case FETCH_RECORDS_GROUP_BY_COACHES_FAILURE:
            return {
                ...state,
                recordsGroupByCoaches: {
                    ...state.recordsGroupByCoaches,
                    loading: false,
                    data: [],
                    error: action.payload
                }
            };

        // Top performing coaches analytics
        case FETCH_TOP_PERFORMING_COACHES_REQUEST:
            return {
                ...state,
                topPerformingCoaches: {
                    ...state.topPerformingCoaches,
                    loading: true,
                    error: null
                }
            };
        case FETCH_TOP_PERFORMING_COACHES_SUCCESS:
            return {
                ...state,
                topPerformingCoaches: {
                    ...state.topPerformingCoaches,
                    loading: false,
                    data: action.payload || null,
                    error: null
                }
            };
        case FETCH_TOP_PERFORMING_COACHES_FAILURE:
            return {
                ...state,
                topPerformingCoaches: {
                    ...state.topPerformingCoaches,
                    loading: false,
                    data: null,
                    error: action.payload
                }
            };

        // Coach details
        case FETCH_COACH_DETAILS_REQUEST:
            return {
                ...state,
                coachDetails: {
                    ...state.coachDetails,
                    loading: true,
                    error: null
                }
            };
        case FETCH_COACH_DETAILS_SUCCESS:
            return {
                ...state,
                coachDetails: {
                    ...state.coachDetails,
                    loading: false,
                    data: action.payload || [],
                    error: null
                }
            };
        case FETCH_COACH_DETAILS_FAILURE:
            return {
                ...state,
                coachDetails: {
                    ...state.coachDetails,
                    loading: false,
                    data: [],
                    error: action.payload
                }
            };

        // Students details
        case FETCH_STUDENTS_DETAILS_REQUEST:
            return {
                ...state,
                studentsDetails: {
                    ...state.studentsDetails,
                    loading: true,
                    error: null
                }
            };
        case FETCH_STUDENTS_DETAILS_SUCCESS:
            return {
                ...state,
                studentsDetails: {
                    ...state.studentsDetails,
                    loading: false,
                    data: action.payload || null,
                    error: null
                }
            };
        case FETCH_STUDENTS_DETAILS_FAILURE:
            return {
                ...state,
                studentsDetails: {
                    ...state.studentsDetails,
                    loading: false,
                    data: null,
                    error: action.payload
                }
            };
        
        default:
            return state;
    }           
}